module.exports = __webpack_public_path__ + "static/media/manchester-riverside.8bfc09b9.jpeg";